import React from 'react';
import { OriginVisual } from './OriginVisual';

export const OriginLeftPanel = ({ origin, down_type }) => {
  return (
    <OriginVisual origin={origin} down_type={down_type} lower="left" />
  );
};